import { ref } from 'vue'
import { projectFirestore } from '../firebase/config'
const getPost = (id) => {
  const post = ref(null);// 放posts
  const error = ref(null);
  const showPost = ref(true); // toggle flag
  const load = async () => {  // 非同步function取資料
    try{  // 若是promise錯誤，則會跑catch，成功則不會跑catch
      let data = await projectFirestore.collection('posts').doc(id).get();
        // 連接Firestore的collection中的其中一doc並且get，await等待資料傳回來，再把物件傳給左邊的data變數，data會是一物件
      if(!data.exists){// promise物件中的ok property為false，則丟error，去跑catch
        throw Error('that data does not exist!')
      }
      post.value = { ...data.data(), id: data.id }; // 將promise物件轉成json回傳
    }
    catch(err) {
      error.value = err.message
    }
	}
	return { post, error, load } // return 使得引入的component可以catch到裡面的變數value
};

export default getPost;